<div class="cardLayout">
  <!-- <ion-row> -->
    <!-- <ion-col size="12"> -->
      <!-- <div class="popup-heading">
        <div>
          <p class="fs-16 fs_14ForMobile font_regular">Market correction employees ({{totalCount}})</p>
         </div>
         <div class="popup-close">
          <button class="download-btn" (click)="exportToExcel()">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            Download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div> -->
 
    <!-- </ion-col> -->
    <ion-col size="12" size-md="12">
      <div class="header-row">
        
        <!-- LEFT SIDE -->
        <div class="left-section">
          <p class="fs-16 fs_14ForMobile font_regular">
            Market correction employees ({{ totalCount }})
          </p>
        </div>
    
        <!-- RIGHT SIDE -->
        <div class="right-section">
          
          <span 
            class="ml-5 mt-10 fs-20 material-icons btn-reset"
            style="cursor:pointer;"
            [class.clicked]="isClicked"
            (click)="resetGrid(); isClicked = true"
            (animationend)="isClicked = false">
            refresh
          </span>
    
          <span 
            class="ml-5 mt-10 fs-20 material-icons icon-download"
            style="cursor:pointer;"
            (click)="onBtExport()">
            download
          </span>
    
          <span 
            [mat-dialog-close]
            class="ml-35 mr-5 fs-30 material-icons popup-close-icon"
            style="cursor:pointer;">
            close
          </span>
    
        </div>
    
      </div>
    </ion-col>
    
  <!-- </ion-row> -->
  
  <ion-row>
    <ion-col size="12">
      <div class="table-container">
        <ag-grid-angular
          class="ag-theme-alpine Market-correction-employees-table"
          style="width: 100%; height: 300px;"
          [rowData]="marketCorrectionRowData"
          [columnDefs]="marketCorrectionColumnDefs"
          [defaultColDef]="defaultColDef"
          [pinnedBottomRowData]="pinnedBottomRowData"
          [pagination]="true"
          [paginationPageSize]="20"
          (gridReady)="onGridReady($event)"
        >
        </ag-grid-angular>
      </div>
      
    </ion-col>
  </ion-row>
</div>